import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { TimeSetupService } from "./shared/data.service";
import { UpdateExitTimeRequest } from "./shared/UpdateExitTimeRequest";
import * as moment from "moment";

@Component({
	selector: "app-time-setup",
	templateUrl: "./time-setup.component.html",
	styleUrls: ["./time-setup.component.css"],
})
export class TimeSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private timeSetupService: TimeSetupService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////
	subscription: any;
	loading: any = false;

	SchoolID: any;
	lstSchool: any = [];

	CorrelateSelectID: any = 0;
	lstCorrelateSelect: any = [
		{
			ID: 0,
			Desc: "School",
		},
		{
			ID: 1,
			Desc: "Academy",
		},
		{
			ID: 2,
			Desc: "Grade",
		},
		{
			ID: 3,
			Desc: "Homeroom",
		},
		{
			ID: 4,
			Desc: "Start Period",
		},
	];

	CorrelateTime: Date = new Date();
	SchoolExitTime: Date = new Date();
	OriginalSchoolExitTime: Date = new Date();

	ExitScan_EarlyBySchoolOnly: boolean = false;
	OriginalExitScan_EarlyBySchoolOnly: boolean = false;
	SchoolExitTimeDesc: string = moment(new Date()).format("h:mm a");

	Prefs: any;

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////
	TimeSettingsLoadPrefs(UpdateSchool) {
		this.loading = true;

		var result = this.timeSetupService.TimeSettingsLoadPrefs(this.SchoolID);
		result.subscribe(
			(response) => {
				this.Prefs = response[0];

				if (this.Prefs != undefined) {
					if (this.Prefs.TardyTypeID != undefined) {
						this.CorrelateSelectID = this.Prefs.TardyTypeID;
					} else {
						this.CorrelateSelectID = 0;
					}

					if (this.Prefs.ExitTime != undefined && this.Prefs.ExitTime != "") {
						var TodayStr: String = moment(new Date()).format("MM/DD/YYYY");

						this.onSchoolExitTimeChange(new Date(TodayStr + " " + this.Prefs.ExitTime));
						this.OriginalSchoolExitTime = new Date(TodayStr + " " + this.Prefs.ExitTime);
					} else {
						var DefaultTime = new Date();
						DefaultTime.setHours(15, 30, 0, 0);
						this.onSchoolExitTimeChange(DefaultTime);
						this.OriginalSchoolExitTime = DefaultTime;
					}

					this.ExitScan_EarlyBySchoolOnly = this.Prefs.ExitScan_EarlyBySchoolOnly;
					this.OriginalExitScan_EarlyBySchoolOnly = this.Prefs.ExitScan_EarlyBySchoolOnly;
				}
				//
				// Error Preference not found
				//
				else {
					this.CorrelateSelectID = 0;
					var DefaultTime = new Date();
					DefaultTime.setHours(15, 30, 0, 0);
					this.onSchoolExitTimeChange(DefaultTime);
					this.OriginalSchoolExitTime = DefaultTime;
				}

				this.loading = false;

				if (UpdateSchool == true) {
					this.selectService.SchoolRefresh("refresh");
				}
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;

				this.TimeSettingsLoadPrefs(false);
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////
	onSetCorrelation() {
		var result = this.timeSetupService.TimeSettingsUpdateTardyType(this.SchoolID, this.CorrelateSelectID);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Tardy Type was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.selectService.SchoolRefresh("refresh");
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Tardy Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onTestValidity() {
		var result = this.timeSetupService.TestTardyTimes(this.SchoolID);
		result.subscribe(
			(response) => {
				var ResultMsg: any = "Result: " + response[0];

				this.confirmationService.confirm({
					key: "main",
					acceptLabel: "Ok",
					rejectVisible: false,
					message: ResultMsg,
					header: "Time Settings",
					icon: "fa",
					accept: () => {},
				});
			},
			(error) => {}
		);
	}

	onUpdateExitTime() {
		var fTime = moment(new Date(this.SchoolExitTime)).format("hh:mm a");

		var parms: UpdateExitTimeRequest = {
			SchoolID: this.SchoolID,
			SchoolExitTime: fTime,
			ExitScan_EarlyBySchoolOnly: this.ExitScan_EarlyBySchoolOnly == true ? 1 : 0,
		};

		var result = this.timeSetupService.TimeSettingsUpdateExitTime(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Exit Time was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.TimeSettingsLoadPrefs(true);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the School Exit Time",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onResetExitTime() {
		var TodayStr: String = moment(new Date()).format("MM/DD/YYYY");

		this.onSchoolExitTimeChange(new Date(TodayStr + " " + this.Prefs.ExitTime));
	}
	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////////
	onSchoolChange(val) {
		this.SchoolID = val;

		//Load Data
		this.TimeSettingsLoadPrefs(false);
	}
	onCorrelateSelectChange(val) {
		this.CorrelateSelectID = val;

		//Load Data
	}
	onSchoolExitTimeChange(val) {
		this.SchoolExitTime = val;

		this.SchoolExitTimeDesc = moment(this.SchoolExitTime).format("h:mm a");
	}
	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////

	IsChanged() {
		if (this.ExitScan_EarlyBySchoolOnly != this.OriginalExitScan_EarlyBySchoolOnly) {
			return true;
		} else if (
			this.SchoolExitTime.getHours() != this.OriginalSchoolExitTime.getHours() ||
			this.SchoolExitTime.getMinutes() != this.OriginalSchoolExitTime.getMinutes()
		) {
			return true;
		} else {
			return false;
		}
	}

	////////////////////////////////////////////////////////
}
